module.exports = __webpack_public_path__ + "static/media/desktop7.f91a865f.png";